export default "__VITE_ASSET__ZCLnc$GM__"